import { FOREIGN_ENTITY_TYPE } from '../../constants/InterventionConstants';

/**
 * @param {import("./types").SelfService} defaultSelfService
 * @returns {import("./types").SelfService}
 */

export const modelFormatter = (defaultSelfService = {}) => {
  const { mobility = {}, checklists, ...selfService } = defaultSelfService;
  const { enabled: mobilityEnabled } = mobility;

  return {
    ...selfService,
    ...(mobilityEnabled ? { mobility } : {}),
    checklists: checklists?.map(checklist => ({ ...checklist, foreignEntityType: FOREIGN_ENTITY_TYPE.SELF_SERVICE })),
  };
};
